export default __webpack_public_path__ + "static/media/ap-soglia.1c60bae1.svg";